// Décodage minimal d'un JWT Keycloak, sans dépendance externe : on ne fait ici QUE lire le
// payload pour l'affichage et les rôles, jamais vérifier la signature (le backend le fait déjà
// sur chaque appel `/api/**`, ce décodage n'est qu'un contrôle d'AFFICHAGE côté tablette).
export function decodeJwt(token) {
  if (!token) return null;
  try {
    const payload = token.split('.')[1];
    const base64 = payload.replace(/-/g, '+').replace(/_/g, '/');
    const padded = base64.padEnd(base64.length + ((4 - (base64.length % 4)) % 4), '=');
    const json = decodeURIComponent(
      atob(padded)
        .split('')
        .map((c) => '%' + c.charCodeAt(0).toString(16).padStart(2, '0'))
        .join('')
    );
    return JSON.parse(json);
  } catch {
    return null;
  }
}

// Rôles = union des rôles realm et des rôles du client "sip-api" — exactement ce que lit le
// backend (SecurityConfig / @PreAuthorize), voir CLAUDE.md sipconfection-frontend, section auth.
export function rolesFromToken(token) {
  const payload = decodeJwt(token);
  if (!payload) return [];
  const realmRoles = payload.realm_access?.roles || [];
  const apiRoles = payload.resource_access?.['sip-api']?.roles || [];
  return Array.from(new Set([...realmRoles, ...apiRoles]));
}

export function displayNameFromToken(token) {
  const payload = decodeJwt(token);
  if (!payload) return null;
  return payload.name || payload.preferred_username || null;
}

// `family_name` = nom de famille Keycloak. Pour les comptes ST, ce nom vaut le `codeUsine` de
// leur atelier (convention reprise d'espace-sous-traitants.component.ts côté sipconfection-
// frontend) — c'est ce qui permet de restreindre le parc visible sans lien Keycloak↔SousTraitant.
export function lastNameFromToken(token) {
  const payload = decodeJwt(token);
  if (!payload) return null;
  return payload.family_name || null;
}

/** `exp` est en secondes epoch ; renvoie le nombre de millisecondes restant, négatif si expiré. */
export function msUntilExpiry(token) {
  const payload = decodeJwt(token);
  if (!payload?.exp) return 0;
  return payload.exp * 1000 - Date.now();
}
